import validate from 'validate';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import $http from '$http'


export default {
    data() {
        return {
            contactInfo: this.refGetContactInfo(),
            visiable: false,
        };
    },
    created() {
        this.visiable = this.value;
    },
    watch: {
        value(val) {
            this.visiable = val;
        },
        visiable(val) {
            this.$emit('input', val);
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        customerId: {
            default: 0
        }
    },
    methods: {
        refGetContactInfo() {
            return cloneDeep({
                "C_Name": "",
                "C_Tel": "",
                "C_Position": "",
                "C_QQ": "",
                "C_Email": "",
                "C_WeiXin": ""

            });
        },
        clearData() {
            this.contactInfo = this.refGetContactInfo();
        },
        close() {
            this.$emit('input', false);
        },
        submit() {
            // this.$emit('change', this.currentRow);
            let rules = [];
            rules.push({
                name: "联系人姓名",
                value: this.contactInfo.C_Name,
                required: true
            });

            rules.push({
                name: "联系人电话",
                value: this.contactInfo.C_Tel,
                phone: true
            });

            let flag = util.checkForm({
                ele: this,
                rules: rules
            });

            if (!flag) {
                return
            }
            
            let Params = Object.assign({}, {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                CustomerId: this.customerId
            }, this.contactInfo);
            //console.log(this.contactInfo)
            $http.post("api/Contact/ContactAdd", Params).then(res => {
                util.doResult(this, res, () => {
                    this.close();
                })
            })

        }
    },
    mounted() {

    }
};


// WEBPACK FOOTER //
// ./src/common/components/info-dialog/vm.js